import React, { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const RefundPage = () => {
  const [orderId, setOrderId] = useState("");
  const [refundAmount, setRefundAmount] = useState("");
  const [message, setMessage] = useState("");

  const handleRefund = async () => {
    try {
      const res = await axios.post(`${API_URL}/orders/${orderId}/refunds`, {
        refund_amount: refundAmount,
        refund_reason: "Customer request",
      });
      setMessage("Refund Requested Successfully: " + JSON.stringify(res.data));
    } catch (err) {
      setMessage("Refund Failed: " + err.response?.data?.error || err.message);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Refund API Demo</h2>
      <input
        type="text"
        placeholder="Order ID"
        value={orderId}
        onChange={(e) => setOrderId(e.target.value)}
        style={{ margin: "10px", padding: "8px" }}
      />
      <input
        type="number"
        placeholder="Refund Amount"
        value={refundAmount}
        onChange={(e) => setRefundAmount(e.target.value)}
        style={{ margin: "10px", padding: "8px" }}
      />
      <br />
      <button
        onClick={handleRefund}
        style={{
          padding: "10px 20px",
          backgroundColor: "#ff6600",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        Request Refund
      </button>
      <p>{message}</p>
    </div>
  );
};

export default RefundPage;
